import React, { useEffect, useState } from "react";
import { getTestimonials } from "../api";
import { Star, Quote, Info } from "lucide-react";

export default function TestimonialsBlock() {
  const [items, setItems] = useState([]);
  useEffect(() => { getTestimonials().then(setItems).catch(() => {}); }, []);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="chip mb-4">Customer Reviews</div>
          <h2 className="font-display text-3xl md:text-5xl font-medium leading-tight">Real feedback from real customers</h2>
        </div>
        {items.length === 0 ? (
          <div className="max-w-xl mx-auto text-center bg-neutral-50 border border-dashed border-neutral-300 rounded-lg p-10">
            <Info className="w-6 h-6 text-slate-400 mx-auto mb-3" />
            <p className="text-slate-600">We&apos;re building this section with real customer reviews. Have you used our service? WhatsApp us your feedback and we&apos;ll add it here.</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((t) => (
              <div key={t.id} className="p-6 rounded-lg border border-neutral-200 hover-card">
                <Quote className="w-6 h-6 text-[#e30613] mb-3" />
                <div className="flex gap-0.5 mb-3">{Array.from({ length: t.rating || 5 }).map((_, i) => (<Star key={i} className="w-4 h-4 fill-[#e30613] text-[#e30613]" />))}</div>
                <p className="text-sm text-slate-700 leading-relaxed mb-5">&ldquo;{t.text}&rdquo;</p>
                <div className="border-t border-neutral-200 pt-4">
                  <div className="font-semibold text-sm">{t.name}</div>
                  {t.area && <div className="text-xs text-slate-500 uppercase tracking-wider">{t.area}</div>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
